import { NodeViewContent } from '@tiptap/react';
import { FC } from 'react';
import { CompanyPageSourceDerivedSectionComponentProps } from './types';

export const CompanyPageSourceDerivedSectionGenerated: FC<
  CompanyPageSourceDerivedSectionComponentProps
> = () => {
  return <NodeViewContent />;
};
